export default [
    'people[].first_name',
    'people[].last_name',
    'people[].title',
    'people[].id_number',
    'people[].phone[].uid',
    'people[].phone[].type',
    'people[].phone[].number',
    'people[].roles',
    'people[].date_of_birth.dd',
    'people[].date_of_birth.mm',
    'people[].date_of_birth.yy',
    'people[].privacy_policy_agreement_date',
    'people[].addresses[].street_line_1',
    'people[].addresses[].street_line_2',
    'people[].addresses[].postcode',
    'people[].addresses[].uid',
    'people[].addresses[].flat_number',
    'people[].addresses[].town',
    'people[].addresses[].house_number',
    'people[].email',
    'people[].emailUID',
    'people[].uid',
    'people[].marketing_emails',
    'people[].data_transfer_consent'
] as string[];
